import { useCallback, useMemo } from 'react';
import { STATIC_ACCESS_TYPES } from 'utils/constants/access-log';

// deviceTypes is passed in by the caller instead of being fetched here. This hook is invoked
// once per access-log row (AccessLogItem), so an internal fetch meant a fresh GET /device-types
// call for every visible row — a real bug, not just inefficiency (looked like an infinite loop
// once infinite-scroll kept mounting more rows). Callers get the map from useDeviceTypes(),
// which fetches once and caches at module scope.
export function useLogType(deviceTypes) {
    const accessMap = useMemo(
        () => ({ ...STATIC_ACCESS_TYPES, ...deviceTypes }),
        [deviceTypes]
    );

    return useCallback(
        log => {
            if (log.lpr_access) return 'LPR';
            if (log.role === 'visitor' && log.access_type === 'visitor') return 'Visitor';
            if (log.role === 'visitor' && log.access_type === 'otc') return 'Code';
            if (log.guard_access) return 'Guard';
            return accessMap[log.access_type] || '';
        },
        [accessMap]
    );
}
